import React from 'react'
import { Col, Button, Form, Modal } from 'react-bootstrap'
import { postDealerSignUp } from '../utils/rest'
import { regexEmail, states, fieldGroup } from '../components/Forms'

import './DealerApplicationForm.css'
//2018-03-11 Final Version - ddfix, the initial values in data... wtf

export default class DealerApplicationForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      validationState: {},
      data: {
		frDealershipName: 'a2',
		frFirstName: 'b2',
		frLastName: 'c2',  
		frTitle: 'd2',

		frWorkPhone: 'e2',   
		frWorkPhoneExt: 'f2',  
		frAddress: 'g2',
		frCity: 'h2',
		frState: 'i2',
		frZip: 'j2',    

		frEMailAddress: 'k2',
				
		frComment: 'l2'
 		},
      errors: [],
      delivered: false,
      enableSubmit: false,


    }

    // populated during render()
    this.type = {}
    this.fieldGroup = fieldGroup.bind(this)
  }

  componentDidMount = () => {
    // IMPORTANT
    // This is required to trigger a second render to generate controls based
    // on this.type (configured on first reneder)
    this.handleReset()
  }

  handleReset = event => {
    if (event) {
      //event.preventDefault()
    }

    let data = {}
    const validationState = {}

    // IMPORTANT
    // This depends on this.type initialized in this.FieldGroup() on first
    // render. See notes in this.FieldGroup.
    Object.keys(this.type).forEach(name => {
      data[name] = ''
      validationState[name] = null
    })

    data = { ...data, ...(this.props.data ? this.props.data : {}) }

    // assume all default data is valid
    if (this.props.data) {
      Object(this.props.data)
        .keys()
        .forEach(name => {
          validationState[name] = 'success'
        })
    }
    this.setState({
      data,
      validationState,
      errors: [],
      enableSubmit: this.hasMinimalData(data),
    })
  }

  handleChange = event => {

    event.preventDefault()
    let { name, value } = event.target

    if (name.match(/PhoneExt/) && !value.match(/^[\d]*$/)) {
      return
    }
    if (name.match(/(Home|Work|Mobile)Phone/) && !value.match(/^[ \d()x-]*$/)) {
      return
    }
    if (name === 'frZip' && !value.match(/^(|[0-9]{5}$)/)) {
      return
    }
    const data = {
      ...this.state.data,
      [name]: value,
    }
    this.setState({
      data,
      enableSubmit: this.hasMinimalData(data),

    })
    
     
  }

  hasMinimalData = (data = this.state.data) => {
    return !!(
      data.frFirstName &&
      data.frLastName &&
      (data.frHomePhone ||
        data.frMobilePhone ||
        data.frWorkPhone ||
        (data.frAddress && data.frCity && data.frState && data.frZip) ||
        data.frEMailAddress)
    )
  }

  handleSubmit = event => {
    event.preventDefault()
    const errors = []
    let valid = true
    let validationState = []
    const data = {}
    if (!this.hasMinimalData()) {
      valid = false
      errors.push = new Error(
        'Please fill out your name and at least one method of contact (email, phone or address)'
      )
    }

    Object.keys(this.state.data).forEach(name => {
      const type = this.type[name]
      let value = this.state.data[name]

      data[name] = typeof value === 'undefined' ? undefined : value.trim()
      if (type !== 'select') {
        validationState[name] = typeof value === 'undefined' ? null : 'success'

        switch (this.type[name]) {
          case 'email':
            if (value && !value.match(regexEmail)) {
              validationState[name] = 'error'
              valid = false
            }
            break
          case 'tel':
            value = value.replace(/[^0-9]/g, '')
            if (value.length && value.length !== 10) {
              validationState[name] = 'error'
              valid = false
            }
            data[name] = value
            break
          case 'number':
            if (!value.match(/^\d*$/)) {
              validationState[name] = 'error'
              valid = false
            }
            break
          default:
            break
        }
      }
      if (name === 'frZip' && !value.match(/^\d{5}$/)) {
        validationState[name] = 'error'
        valid = false
      }
    })

    if (valid) {
      postDealerSignUp(this.state.data)
        .then(delivered => this.setState({ delivered }))
        .catch(err => {
          this.setState({
            errors: [
              'The server could not process your request at this time. Please try again later.',
            ],
          })
          console.error(`Dealer Application Form: ${err}`, this.state.data)
        })
    } else {
      errors.push(new Error('Please fix form errors.'))
    }

    this.setState({
      validationState,
      enableSubmit: this.hasMinimalData(),
      errors,
    })
  }

  render = () => {
    const FieldGroup = this.fieldGroup

    return this.state.delivered ? (
      <div id="DealerApplicationForm">
        <p className="response">{this.state.delivered.message}</p>
      </div>
    ) : (
      <Form
        id="DealerApplicationForm"
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onReset={this.handleReset}
      >
        <Modal
          className="error-modal"
          show={this.state.errors.length > 0}
          onHide={_ => this.setState({ errors: [] })}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <p className="error">
              {this.state.errors.map((error, i) => (
                <p key={i} className="error">{`${error}`}</p>
              ))}
            </p>
          </Modal.Body>
        </Modal>
        <Col xsOffset={3} xs={9}>
          <h3>{this.props.title}</h3>
        </Col>
        <FieldGroup
          id="frDealershipName"
          label="Dealership Name"
          maxLength="20"
          required
        />
        <FieldGroup
          id="frTitle"
          label="Title"
          minLength="1"
          type="select"
           value={this.state.data.frTitle}  onChange={this.handleChange}
          required
        >
          <option value="" />
          <option value="Sales Manager">Sales Manager</option>
          <option value="Salesman">Salesman</option>
          <option value="Internet Manager">Internet Manager</option>
          <option value="Owner">Owner</option>
          <option value="technology Team">Technology Team</option>
          <option value="Other">Other</option>
        </FieldGroup>
        <FieldGroup
          id="frFirstName"
          label="First Name"
          maxLength="20"
          required
        />
        <FieldGroup id="frLastName" label="Last Name" maxLength="20" required />
        <FieldGroup id="frAddress" label="Address" maxLength="30" />
        <FieldGroup id="frCity" label="City" maxLength="20" />
        <FieldGroup
          id="frState"
          label="State"
          minLength="2"
          maxLength="2"
          type="select"
           value={this.state.data.frState}  onChange={this.handleChange}>
        >
          {['', ...states].map(state => (
            <option value={state} key={state}>
              {state}
            </option>
          ))}
        </FieldGroup>
        <FieldGroup id="frZip" label="Zip Code" type="number" maxLength="5" />
        <FieldGroup
          id="frWorkPhone"
          label="Work Phone"
          type="tel"
          maxLength="20"
        />
        <FieldGroup
          id="frWorkPhoneExt"
          label="Ext."
          type="number"
          maxLength="10"
        />
        <FieldGroup
          id="frEMailAddress"
          label="Email"
          type="email"
          maxLength="30"
                    required
        />

        <FieldGroup
          id="frComment"
          label="Comment"
          maxLength="90"
        />

        <Col xs={9} xsOffset={3}>
          <Button
            type="submit"
            title={
              this.state.enableSubmit
                ? 'Send your contact information'
                : 'Please fill in your name plus one form of contact (phone, mailing address, or email)'
            }
            disabled={!this.state.enableSubmit}
          >
            Send Contact Information
          </Button>{' '}
          <Button type="reset" title="Clear the form">
            Reset Form
          </Button>
        </Col>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DealerApplicationForm.js